module.exports = __webpack_public_path__ + "img/banner-01.f87d7ce1.png";